"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgGenderFemale = function SvgGenderFemale(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 11 20"
  }, props), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1)",
    stroke: "#E568B2",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.198 12.083 3.95 6.614a1 1 0 0 1 .894-.55h1.28a1 1 0 0 1 .89.545l2.803 5.483a1 1 0 0 1-.89 1.455H8.14a1 1 0 0 0-1 1v2.77a1 1 0 0 1-1 1H4.972a1 1 0 0 1-1-1v-2.793a1 1 0 0 0-1.009-1l-.863.008a1 1 0 0 1-.902-1.45Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.614,
    cy: 2.159,
    r: 2.159
  })));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgGenderFemale);
var _default = exports["default"] = Memo;